import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import getUserFromToken from "../../utils/getUserFromToken";
import getUserNameFromToken from "../../utils/getUserNameFromToken";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const EmployeeId = getUserFromToken();
  const navigate = useNavigate();
  const UserName = getUserNameFromToken();
//   // console.log("getuserName", UserName);

  const handleLogout = () => {
    localStorage.clear();
    toast.success("Logged Out");
    navigate("/admin/auth/login");
  };

const onFinish = async (values) => {
  try {
    setLoading(true);
    const response = await axios.post("user/ChangePassword", {
      UserName: UserName,
      OldPassword: values.OldPassword,
      NewPassword: values.NewPassword,
    });

    if (response.status === 200) {
      toast.success("Password changed successfully");
      handleLogout();
    } else {
      toast.error("Failed to change password");
    }
  } catch (error) {
    // Show the exact error message from API
    if (error.response && error.response.data && error.response.data.message) {
      toast.error(error.response.data.message);
    } else {
      toast.error("Failed to change password");
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div
      style={{ display: "flex", justifyContent: "center", alignItems: "top" }}
    >
      <Card style={{ width: 400, padding: "20px" }}>
        <h2
          style={{
            textAlign: "center",
            marginBottom: "20px",
            fontWeight: "bold",
            fontSize: "20px",
          }}
        >
          Change Password
        </h2>
        <Form name="reset_password" layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="OldPassword"
            label="Old Password"
            rules={[
              { required: true, message: "Please enter your old password!" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter old password"
            />
          </Form.Item>

          <Form.Item
            name="NewPassword"
            label="New Password"
            rules={[
              { required: true, message: "Please enter your new password!" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter new password"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Confirm Password"
            dependencies={["NewPassword"]}
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("NewPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Confirm new password"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}>
              Change Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ResetPassword;
